import React, { useEffect, useRef, useState } from "react";
import './Statistics.css';
import { BASE_URL } from "../../config";
import axios from "axios";
import { getAccessToken } from "../LoginForm/Auth/auth";

const Statistics = ({ ojInfo }) => {
  const [stats, setStats] = useState({
    brojTrafostanica: 0,
    brojKorisnika: 0,
    duzinaMreze: 0,
  });

  const isDirekcija = !ojInfo?.Šifra || !ojInfo?.Naziv;

  // Funkcija za dohvatanje broja zapisa ili sumiranje
  const getStatsFromGeoServer = async (layerName, idOfOj, type) => {
    try {
      const url = `${BASE_URL}/geoserver/wfs?service=WFS&version=1.0.0&request=GetFeature&typeName=${layerName}&outputFormat=application/json&CQL_FILTER=id_terenske_jedinice=${idOfOj}`;
      const token = getAccessToken();

      const response = await axios.get(url, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      const data = response.data;
      if (type === "count") {
        return data.features.length; // Broj zapisa
      } else if (type === "sum") {
        return data.features.reduce((sum, feature) => sum + (feature.properties.duzina || 0), 0); // Suma dužina
      }
    } catch (error) {
      console.error(`Greška u komunikaciji sa GeoServer-om za sloj ${layerName}:`, error.response ? error.response.data : error.message);
      return 0;
    }
  };

  // Poziv funkcije za dohvatanje statistike kada se promeni `idOfOj`
  const prevIdRef = useRef(null);

  useEffect(() => {
    let isMounted = true;

    const runFetch = async () => {
      if (!isDirekcija && ojInfo?.Šifra !== prevIdRef.current) {
        prevIdRef.current = ojInfo.Šifra;
        const idOfOj = ojInfo.Šifra;

        const brojTrafostanica = await getStatsFromGeoServer("elektro:trafo_stanice", idOfOj, "count");
        const brojKorisnika = await getStatsFromGeoServer("elektro:mjerna_mjesta", idOfOj, "count");
        const duzinaMreze = await getStatsFromGeoServer("elektro:dionica", idOfOj, "sum");

        if (isMounted) {
          setStats({
            brojTrafostanica,
            brojKorisnika,
            duzinaMreze: duzinaMreze / 1000,
          });
        }
      }
    };

    runFetch();

    return () => {
      isMounted = false;
    };
  }, [ojInfo, isDirekcija]);

  return (
    <div className="statistics-info">
      <h6>Radna jedinica: {isDirekcija ? 'Direkcija' : ojInfo?.Naziv}</h6>

      {!isDirekcija && (
        <>
          <div className="stat-item">
            <span>Dužina mreže:</span>
            <strong>{stats.duzinaMreze.toFixed(2)} km</strong>
          </div>
          <div className="stat-item">
            <span>Broj trafostanica:</span>
            <strong>{stats.brojTrafostanica}</strong>
          </div>
          <div className="stat-item">
            <span>Broj korisnika:</span>
            <strong>{stats.brojKorisnika}</strong>
          </div>
        </>
      )}
    </div>
  );
};

export default Statistics;
